
import { VersionService } from "@services/version.service";
import * as angular from "angular";
import "./site-updated-indicator.component.scss";

class SiteUpdatedIndicatorComponentController implements angular.IComponentController {

    show: boolean;

    static $inject = ["$rootScope", "$window", "versionService"];

    constructor(
        private $rootScope: angular.IRootScopeService,
        private $window: angular.IWindowService,
        private versionService: VersionService) {

        this.$rootScope.$on("versionUpdated", (event, newVersion: string, previousVersion: string) => {
            this.versionUpdated();
        });
    }

    $onInit(): void {
    }

    refresh() {
        this.$window.location.reload(true);
    }

    dismiss() {
        this.show = false;
    }

    // ---

    private versionUpdated() {
        this.show = true;
    }
}

export class SiteUpdatedIndicator implements angular.IComponentOptions {
    bindings: any;
    template: string;
    controller: any;

    constructor() {
        this.bindings = {};

        this.controller = SiteUpdatedIndicatorComponentController;

        this.template = require("./site-updated-indicator.component.html");
    }
}
